// @ts-check
import React, { Component } from 'react';
import { Page, Row, Widget } from 'shared/containers/portal_layout';
import api from 'utils/api';
import HForm, {
  TextField,
  SelectField,
  DateMaskField,
} from 'shared/containers/portal_layout/HForm';
import { reduxForm } from 'utils/reduxFormWrapper';
import Errors from 'shared/components/Errors';
import { decamelizeKeys } from 'humps';
import SpinnerButton from 'shared/components/SpinnerButton';
import { connect } from 'react-redux';
import * as PayersActions from 'shared/actions/PayersActions';
import { PresentationComponent as CoverageDetails } from 'shared/components/InsuranceCoverages/Show/Show.js';

class New extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { results: null };
    this.checkEligibility = this.checkEligibility.bind(this);
    this.back = this.back.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(PayersActions.payersRequested());
  }

  checkEligibility(formValues) {
    return api
      .post(`/agent_portal/api/eligibility_checks`, {
        form: decamelizeKeys(formValues),
      })
      .then(response => {
        this.setState({ results: response.data });
        return null;
      });
  }

  back() {
    this.setState({ results: null });
  }

  render() {
    return (
      <FormifiedPresentationComponent
        form="newEligibilityCheck"
        onSubmit={this.checkEligibility}
        results={this.state.results}
        back={this.back}
      />
    );
  }
}

const PresentationComponent = ({ handleSubmit, error, submitting, results, payers, back }) => (
  <Page title="Eligibility Check">
    <Row>
      {results ? (
        <CoverageDetails {...results} back={back} />
      ) : (
        <Widget className="nopadding" title="Patient Information" span={12}>
          <HForm onSubmit={handleSubmit}>
            <Errors errors={error || []} />
            <TextField name="lastName" label="Patient Last Name" />
            <TextField name="firstName" label="Patient First Name" />
            <DateMaskField
              name="dobString"
              label="Patient DOB"
              mask="dob"
              placeholder="mm/dd/yyyy"
            />

            <SelectField
              label="Payer"
              className="input-xlarge required payer-select"
              name="payerId"
              options={payers.items}
              valueKey="id"
              labelKey="name"
              isLoading={payers.isFetching}
              placeholder="Select Payer..."
            />

            <TextField
              label="Insurance Member ID"
              name="membershipIdCode"
              type="text"
              className="input-large"
              placeholder="Insurance Member ID"
            />

            <div className="form-actions">
              <SpinnerButton type="submit" className="btn btn-primary" loading={submitting}>
                Check Eligibility
              </SpinnerButton>
            </div>
          </HForm>
        </Widget>
      )}
    </Row>
  </Page>
);

const mapStateToProps = (state, ownProps) => {
  return {
    payers: state.payers,
  };
};

const FormifiedPresentationComponent = reduxForm({})(
  connect(mapStateToProps)(PresentationComponent)
);

export default connect(mapStateToProps)(New);
